var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.164 0 0 7.164 0 16C0 24.836 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM24.6187 12.7133C24.6267 12.8907 24.6307 13.0667 24.6307 13.2427C24.6307 18.6667 20.504 24.9173 12.956 24.9173C10.6373 24.9173 8.48133 24.2387 6.66667 23.0733C6.988 23.112 7.31467 23.1293 7.64667 23.1293C9.57067 23.1293 11.3387 22.4747 12.7413 21.372C10.9453 21.3387 9.42933 20.152 8.908 18.5227C9.15867 18.5707 9.416 18.596 9.68 18.596C10.0547 18.596 10.4187 18.5453 10.7613 18.452C8.884 18.076 7.46933 16.4173 7.46933 14.4293C7.46933 14.412 7.46933 14.3947 7.46933 14.3773C8.02267 14.6853 8.65467 14.8693 9.328 14.8907C8.228 14.156 7.50267 12.8987 7.50267 11.476C7.50267 10.7227 7.704 10.0173 8.05733 9.41333C10.0813 11.896 13.1053 13.5307 16.5147 13.7013C16.4453 13.4013 16.4093 13.088 16.4093 12.7667C16.4093 10.5013 18.2467 8.66267 20.512 8.66267C21.692 8.66267 22.7587 9.16133 23.5067 9.95867C24.4413 9.77333 25.32 9.43333 26.1133 8.96267C25.8067 9.92133 25.156 10.724 24.308 11.2333C25.1373 11.1347 25.928 10.9147 26.6653 10.588C26.1173 11.412 25.4227 12.1333 24.6187 12.7133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9b98d8cc0036258641567cbfd4faf0fa.svg";
export { ForwardRef as ReactComponent };